export default __webpack_public_path__ + "static/media/hero2.7c4ea694.png";